export default function Spacer() {
  return <div className="w(fill) h(fill)" />;
}
